import { Component, Inject } from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderComponent} from "../../order-manager/order/order.component";
import {catchError, throwError} from "rxjs";
import {NotesService} from "../../../services-otc/notes.service";
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';

@Component({
    selector: 'app-add-note',
    templateUrl: './add-note.component.html',
    styleUrls: ['./add-note.component.css'],
    standalone: false
})
export class AddNoteComponent {

  note: string = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        private newNoteFb: FormBuilder,
        public dialogRef: MatDialogRef<OrderComponent>,
      private notesService: NotesService,
      public nav: NavBarComponent,
    ) {
  }

  onInputChange(event: any): void {
    this.note = event.target.value;
  }

  cancelAddingNote(){
    this.dialogRef.close();
  }
 createNewOrderNote() {
  this.nav.toggleLoading(true);
      if(this.data.orderId){
          let noteObj = {
              note: this.note,
              orderId: this.data?.orderId,
          };
          this.notesService.postNewNote(noteObj.note, noteObj.orderId).pipe(
              catchError(error => {
                  console.error(error);
                  return throwError(() => error);
              })
          ).subscribe(() => {
              this.dialogRef.close();
              this.nav.toggleLoading(false);
          });
      }
  }

}
